var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    {
      attrs: { title: _vm.activateSpinner ? "" : _vm.$t("Webheader.company") },
    },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "overflow-hidden" },
          [
            _c(
              "b-row",
              { staticClass: "no-gutters" },
              [
                _c("b-col", { attrs: { md: "12" } }, [
                  _c("div", { staticClass: "requestsList" }, [
                    _c(
                      "div",
                      { staticClass: "mt-0" },
                      [
                        _vm.activateSpinner
                          ? _c("spinner")
                          : _c(
                              "div",
                              { staticClass: "overflow-x-unset" },
                              [
                                _c(
                                  "f7-list",
                                  { staticClass: "mb-2" },
                                  [
                                    _c(
                                      "f7-list-item",
                                      { class: _vm.additionalClass },
                                      [
                                        _c("div", { staticClass: "d-flex" }, [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "btn btnFilter",
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.displayFilter =
                                                        !_vm.displayFilter
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm.displayFilter
                                                    ? _c("i", {
                                                        staticClass:
                                                          "fa-light fa-minus",
                                                      })
                                                    : _c("i", {
                                                        staticClass:
                                                          "fa-light fa-plus",
                                                      }),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "mx-3" },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "btn btnFilter",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.refreshInbox()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-light fa-rotate-right",
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "btn btnFilter_2",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.exportCompany()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-light fa-upload",
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "fab-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "common.extract_list"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.displayFilter
                                            ? _c("div", {
                                                staticClass:
                                                  "d-flex flex-row-reverse mt-5px",
                                                attrs: {
                                                  cols: "4",
                                                  offset: "8",
                                                },
                                              })
                                            : _vm._e(),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "f7-list-item",
                                      {
                                        class: {
                                          "filter-item-section": true,
                                          "d-none": !_vm.displayFilter,
                                        },
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          { staticClass: "min-w-100" },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "filter-item mb-5",
                                                attrs: { lg: "3", cols: "6" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "filter-item-title",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "administration.active"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "filter-item-content",
                                                  },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.active,
                                                            expression:
                                                              "active",
                                                          },
                                                        ],
                                                        ref: "selectDoctype",
                                                        staticClass:
                                                          "pt-1 z-2 h-auto cursor fs-14px-important",
                                                        on: {
                                                          input:
                                                            _vm.delayApplyFilter,
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$selectedVal =
                                                              Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function (o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function (
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                            _vm.active = $event
                                                              .target.multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "administration.select_activity"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "0",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "administration.no"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "1",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "administration.in_prgrss"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "2",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "administration.yes"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-chevron-down p-1 z-1 float-right cursor mt--22px-important",
                                                      attrs: {
                                                        id: "status-chevron",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "filter-item mb-5",
                                                attrs: { lg: "3", cols: "6" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "filter-item-title",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "administration.user_login"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "filter-item-content",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.identifier,
                                                          expression:
                                                            "identifier",
                                                        },
                                                      ],
                                                      class: {
                                                        "filter-item-input": true,
                                                        "filter-item-input-complete":
                                                          _vm.identifier,
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: _vm.$t(
                                                          "administration.enter_id"
                                                        ),
                                                      },
                                                      domProps: {
                                                        value: _vm.identifier,
                                                      },
                                                      on: {
                                                        input: [
                                                          function ($event) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.identifier =
                                                              $event.target.value
                                                          },
                                                          _vm.delayApplyFilter,
                                                        ],
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "filter-item",
                                                attrs: { lg: "3", cols: "6" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "filter-item-title",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "administration.user"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "filter-item-content",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.name,
                                                          expression: "name",
                                                        },
                                                      ],
                                                      class: {
                                                        "filter-item-input": true,
                                                        "filter-item-input-complete":
                                                          _vm.name,
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: _vm.$t(
                                                          "administration.enter_company_name"
                                                        ),
                                                      },
                                                      domProps: {
                                                        value: _vm.name,
                                                      },
                                                      on: {
                                                        input: [
                                                          function ($event) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.name =
                                                              $event.target.value
                                                          },
                                                          _vm.delayApplyFilter,
                                                        ],
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "d-flex flex-row-reverse mt-3",
                                                attrs: { lg: "3", cols: "12" },
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "btn",
                                                    attrs: { size: "sm" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.applyFilter()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.$t("common.srch")
                                                        ) +
                                                        "\n                        "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "btn mr-3",
                                                    attrs: {
                                                      size: "sm",
                                                      disabled:
                                                        !_vm.hasInputFilter,
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.clearFilterFields,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "filter.clr_fltr_field"
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.CompaniesList.length
                                  ? _c("b-table", {
                                      staticClass: "mt-3",
                                      attrs: {
                                        hover: "",
                                        items: _vm.CompaniesList,
                                        fields: _vm.companyFields,
                                        selectable:
                                          _vm.CompaniesList.length > 0,
                                        "empty-text": _vm.$t(
                                          "common.security.no_result"
                                        ),
                                      },
                                      on: {
                                        "row-selected": _vm.seeCompanyDetails,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "cell(active)",
                                            fn: function (data) {
                                              return [
                                                data.value === "0"
                                                  ? _c("div", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-duotone fa-xmark btn btn-icon btn-icon-red",
                                                      }),
                                                    ])
                                                  : data.value === "1"
                                                  ? _c("div", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-duotone fa-warning btn btn-icon btn-icon-orange",
                                                      }),
                                                    ])
                                                  : data.value === "2"
                                                  ? _c("div", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-duotone fa-check btn btn-icon btn-icon-green",
                                                      }),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(edit)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-center d-inline-block py-4 w-100",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.activateEdit(
                                                          $event,
                                                          data.value
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-regular fa-pencil",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(delete)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-center d-inline-block py-4 w-100",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.activateDelete(
                                                          $event,
                                                          data.value
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-trash",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span"),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3483257926
                                      ),
                                    })
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "noResult" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("common.no_result")
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "justify-content-end mt-3 no-gutters",
                                  },
                                  [
                                    _vm.canUserAddCompagny
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "mt-3",
                                            attrs: { variant: "primary" },
                                            on: { click: _vm.addCompany },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-light fa-plus fs-17px",
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "administration.company_add"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }